/**
 * Thin re-export over the shared `apiRequest` helper, with an opt-in
 * fixture-client switch for dev demos. See
 * `aidlc-docs/construction/knowledge-base/nfr-design/pr-d-dashboard.md` § 2.
 */

import { apiRequest as realApiRequest, AgentsApiError } from "../../agents/api/client";

import { fixtureApiRequest } from "./__fixtures__/fixture-client";
import { KB_FIXTURES_ENABLED } from "./__fixtures__/fixture-flag";

export const apiRequest = KB_FIXTURES_ENABLED ? fixtureApiRequest : realApiRequest;

export { AgentsApiError as KbApiError };
